import { t } from 'i18next';

// Human-readable names for the BullMQ technical queue keys, shared between
// the queue-depth block and the fair queue block of the health panel.
// Kept as a function (not a module-level map) so the labels re-resolve
// through i18next rather than freezing at module-load time — same
// convention as queueLabel() in internal-admin/fair-queue/index.tsx.
export const queueLabel = (queueName: string): string => {
  const labels: Record<string, string> = {
    oneTimeJobs: t('Flow executions'),
    webhookJobs: t('Webhooks'),
    repeatableJobs: t('Scheduled jobs'),
    usersInteractionJobs: t('User interactions'),
  };
  return labels[queueName] ?? queueName;
};
